import { TEACHER_INFO_MENU_ITEMS } from '@/constants/login'
import React from 'react'
import { logOut } from '@yuanfudao/metis-unified-login'
import config from '@/config'

import lessModule from './index.module.less'

function TeacherInfoMenu(props: any) {
  const clickLogOut = async () => {
    await logOut(false)
    const { href } = window.location
    const [base] = href.split('#')
    window.location.replace(`${config.loginURL}?redirectUrl=${base}#/home`)
  }

  const renderMap:{[key:string]: JSX.Element} = {
    [TEACHER_INFO_MENU_ITEMS.LOGOUT]: <div className={lessModule.option} onClick={clickLogOut}><i className={lessModule.logout} />退出登录</div>,
  }
  return (
    <div className={lessModule.infoContainer}>
      <div className={lessModule.infoMenu}>
        {
          Object.keys(renderMap).map((item) => {
            if (props.menuArr.includes(item)) {
              return <div key={item}>{renderMap[item]}</div>
            }
            return null
          })
        }
      </div>
    </div>
  )
}

export default TeacherInfoMenu
